import type { OrdenServicioConRelaciones } from '@/modules/ordenes-servicio/tipos'
import { Cargando } from '@/shared/ui/Estados/Cargando'

import { HojaCotizacion } from './HojaCotizacion'
import { HojaDeLaOrden } from './HojaDeLaOrden'
import { useHojaDeLaObra } from './useHojaDeLaObra'

/**
 * El documento completo de la obra: todas sus cotizaciones en una hoja.
 *
 * Con un solo documento no hay nada que juntar, y se abre ese mismo con su
 * número de verdad —la hoja de siempre—. Con más de uno, el consolidado.
 */
export function HojaDeLaObra({
  orden,
  onCerrar,
}: {
  orden: OrdenServicioConRelaciones
  onCerrar: () => void
}) {
  const { data, isLoading } = useHojaDeLaObra(orden)

  if (isLoading || !data) return <Cargando mensaje="GENERANDO DOCUMENTO OBRA..." />
  if (data.documentos <= 1) return <HojaDeLaOrden orden={orden} onCerrar={onCerrar} />

  return <HojaCotizacion datos={data.datos} onCerrar={onCerrar} />
}
